//@flow
import queryString from 'qs';

let originalQueryString;
let preservedQueryParams;
const allowedPattern = new RegExp([
  /^((?:afid$)|(?:utm)|(?:nbox)|(?:promo_code$)|(?:aff_sub2)|(?:banner))/
  ,/|^(?:nb_*)/,
].map(r => r.source).join(''));

export default {
  saveOriginalQueryString(w:{location:Location}) {
    originalQueryString = w.location.search;

    if (originalQueryString && originalQueryString[0] === '?') {
      originalQueryString = originalQueryString.substring(1);
    }

    // Save the preserved query
    const query = queryString.parse(originalQueryString);
    this.updatePreservedQueryParams(query);
  },

  getOriginalQueryString():string {
    return originalQueryString;
  },

  updatePreservedQueryParams(query:{[string]:string}){
    preservedQueryParams = {};
    Object.keys(query).forEach((param) => {
      if (param.match(allowedPattern)) {
        preservedQueryParams[param] = query[param];
      }
    });
  },

  getCheckoutQueryParams():{[string]:string} {
    if (!preservedQueryParams) return {};
    return Object.assign({}, preservedQueryParams);
  },

  addCheckoutQueryParamsToUrl(url:?string):string {
    if (!url) {
      return '';
    }

    const queryIndex = url.indexOf('?');
    const baseUrl = queryIndex === -1 ? url : url.substring(0, queryIndex);
    const urlParams = queryIndex === -1 ? {} : queryString.parse(url.substring(queryIndex + 1));
    const checkoutParams = this.getCheckoutQueryParams();
    const params = queryString.stringify(Object.assign({}, checkoutParams, urlParams));
    return params ? baseUrl + '?' + params : baseUrl;
  },
};
